let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("n3xnn")).then(() => parcelRequire('bJeNZ'));